import { useMemo } from "react";
import { useRouter } from "next/router";

import { resolveLanguage } from "helpers";

export const useLanguage = () => {
  const router = useRouter();
  const { country: countryQuery, language: languageQuery } = router.query;

  const language: string = useMemo(
    () => resolveLanguage(countryQuery, languageQuery),
    [countryQuery, languageQuery]
  );

  return language;
};
